"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _IconCarFilled = _interopRequireDefault(require("./IconCarFilled"));

var _IconFireFilled = _interopRequireDefault(require("./IconFireFilled"));

var _IconTheftFilled = _interopRequireDefault(require("./IconTheftFilled"));

var _IconOthersFilled = _interopRequireDefault(require("./IconOthersFilled"));

var _IconTaxFilled = _interopRequireDefault(require("./IconTaxFilled"));

var _IconLegalFilled = _interopRequireDefault(require("./IconLegalFilled"));

var _IconNotificationBellFilled = _interopRequireDefault(require("./IconNotificationBellFilled"));

var _IconFlightFilled = _interopRequireDefault(require("./IconFlightFilled"));

var _IconConsumerFilled = _interopRequireDefault(require("./IconConsumerFilled"));

var _IconMechanicalBreakdownFilled = _interopRequireDefault(require("./IconMechanicalBreakdownFilled"));

var _IconOilFilled = _interopRequireDefault(require("./IconOilFilled"));

var _IconHistoryFilled = _interopRequireDefault(require("./IconHistoryFilled"));

var _IconIncomeFilled = _interopRequireDefault(require("./IconIncomeFilled"));

var _IconElectricityFilled = _interopRequireDefault(require("./IconElectricityFilled"));

var _IconThawingFilled = _interopRequireDefault(require("./IconThawingFilled"));

var _IconWaterDamageFilled = _interopRequireDefault(require("./IconWaterDamageFilled"));

var _IconSnowPressureFilled = _interopRequireDefault(require("./IconSnowPressureFilled"));

var _IconCracksFilled = _interopRequireDefault(require("./IconCracksFilled"));

var _IconDryRotFilled = _interopRequireDefault(require("./IconDryRotFilled"));

var _IconScorchDamageFilled = _interopRequireDefault(require("./IconScorchDamageFilled"));

var _IconPropertyFilled = _interopRequireDefault(require("./IconPropertyFilled"));

var _IconBaggageFilled = _interopRequireDefault(require("./IconBaggageFilled"));

var _IconNaturalDisasterFilled = _interopRequireDefault(require("./IconNaturalDisasterFilled"));

var _IconAssistancePersonFilled = _interopRequireDefault(require("./IconAssistancePersonFilled"));

var _IconAssistanceCarFilled = _interopRequireDefault(require("./IconAssistanceCarFilled"));

var _IconNewCarFilled = _interopRequireDefault(require("./IconNewCarFilled"));

var _IconLookingForCarFilled = _interopRequireDefault(require("./IconLookingForCarFilled"));

var _IconBoughtCarFilled = _interopRequireDefault(require("./IconBoughtCarFilled"));

var _IconSecondHandCarFilled = _interopRequireDefault(require("./IconSecondHandCarFilled"));

var _IconAccidentFilled = _interopRequireDefault(require("./IconAccidentFilled"));

var _IconWebWorldFilled = _interopRequireDefault(require("./IconWebWorldFilled"));

var _IconWebFilled = _interopRequireDefault(require("./IconWebFilled"));

var _IconPersonalLiabilityFilled = _interopRequireDefault(require("./IconPersonalLiabilityFilled"));

var _IconLiabilitybuildingFilled = _interopRequireDefault(require("./IconLiabilitybuildingFilled"));

var _IconLandlordFilled = _interopRequireDefault(require("./IconLandlordFilled"));

var _IconTenantFilled = _interopRequireDefault(require("./IconTenantFilled"));

var _IconGlassBreakageFilled = _interopRequireDefault(require("./IconGlassBreakageFilled"));

var _IconActionDropDown = _interopRequireDefault(require("./IconActionDropDown"));

var _IconActionClose = _interopRequireDefault(require("./IconActionClose"));

var _IconActionMarker = _interopRequireDefault(require("./IconActionMarker"));

var _IconActionPhone = _interopRequireDefault(require("./IconActionPhone"));

var _IconActionPower = _interopRequireDefault(require("./IconActionPower"));

var _IconActionChevronLeft = _interopRequireDefault(require("./IconActionChevronLeft"));

var _IconActionChevronRight = _interopRequireDefault(require("./IconActionChevronRight"));

var _IconActionEye = _interopRequireDefault(require("./IconActionEye"));

var _IconActionEyeCrossed = _interopRequireDefault(require("./IconActionEyeCrossed"));

var _IconActionRead = _interopRequireDefault(require("./IconActionRead"));

var _IconActionUnRead = _interopRequireDefault(require("./IconActionUnRead"));

var _IconActionPlus = _interopRequireDefault(require("./IconActionPlus"));

var _IconActionMessage = _interopRequireDefault(require("./IconActionMessage"));

var _IconStatusExclamation = _interopRequireDefault(require("./IconStatusExclamation"));

var _IconStatusCheck = _interopRequireDefault(require("./IconStatusCheck"));

var _IconStudent = _interopRequireDefault(require("./IconStudent"));

var _IconDashboard = _interopRequireDefault(require("./IconDashboard"));

var _IconSettingsFilled = _interopRequireDefault(require("./IconSettingsFilled"));

var _IconUnderwritingFilled = _interopRequireDefault(require("./IconUnderwritingFilled"));

var _IconClaimsFilled = _interopRequireDefault(require("./IconClaimsFilled"));

var _IconToolkitFilled = _interopRequireDefault(require("./IconToolkitFilled"));

var _IconFamilyFilled = _interopRequireDefault(require("./IconFamilyFilled"));

var _IconActivePVFilled = _interopRequireDefault(require("./IconActivePVFilled"));

var _IconWitnessFilled = _interopRequireDefault(require("./IconWitnessFilled"));

var _IconQualityFilled = _interopRequireDefault(require("./IconQualityFilled"));

var _IconSmsFilled = _interopRequireDefault(require("./IconSmsFilled"));

var _IconWorkAccidentFilled = _interopRequireDefault(require("./IconWorkAccidentFilled"));

var _IconIdFilled = _interopRequireDefault(require("./IconIdFilled"));

var _IconDocumentFilled = _interopRequireDefault(require("./IconDocumentFilled"));

var _IconAtticFilled = _interopRequireDefault(require("./IconAtticFilled"));

var _IconBasementFilled = _interopRequireDefault(require("./IconBasementFilled"));

var _IconPassiveHouseFilled = _interopRequireDefault(require("./IconPassiveHouseFilled"));

var _IconConstructionFilled = _interopRequireDefault(require("./IconConstructionFilled"));

var _IconStoneFilled = _interopRequireDefault(require("./IconStoneFilled"));

var _IconCornFilled = _interopRequireDefault(require("./IconCornFilled"));

var _IconMeasureFilled = _interopRequireDefault(require("./IconMeasureFilled"));

var _IconJewelryFilled = _interopRequireDefault(require("./IconJewelryFilled"));

var _IconArtFilled = _interopRequireDefault(require("./IconArtFilled"));

var _IconFurnitureFilled = _interopRequireDefault(require("./IconFurnitureFilled"));

var _IconGarageFilled = _interopRequireDefault(require("./IconGarageFilled"));

var _IconGuestsFilled = _interopRequireDefault(require("./IconGuestsFilled"));

var _IconPropertyExtraFilled = _interopRequireDefault(require("./IconPropertyExtraFilled"));

var _IconHomeOfficeFilled = _interopRequireDefault(require("./IconHomeOfficeFilled"));

var _IconPoolFilled = _interopRequireDefault(require("./IconPoolFilled"));

var _IconShedFilled = _interopRequireDefault(require("./IconShedFilled"));

var _IconGardenFilled = _interopRequireDefault(require("./IconGardenFilled"));

var _IconVacationFilled = _interopRequireDefault(require("./IconVacationFilled"));

var _IconSurroundingsFilled = _interopRequireDefault(require("./IconSurroundingsFilled"));

var _IconPetsFilled = _interopRequireDefault(require("./IconPetsFilled"));

var _IconEStepFilled = _interopRequireDefault(require("./IconEStepFilled"));

var _IconBikeFilled = _interopRequireDefault(require("./IconBikeFilled"));

var _IconSharedEconomyFilled = _interopRequireDefault(require("./IconSharedEconomyFilled"));

var _IconSolarPanelsFilled = _interopRequireDefault(require("./IconSolarPanelsFilled"));

var _IconDisabilityFilled = _interopRequireDefault(require("./IconDisabilityFilled"));

var _IconChildrenFilled = _interopRequireDefault(require("./IconChildrenFilled"));

var _IconComputerFilled = _interopRequireDefault(require("./IconComputerFilled"));

var _IconAllRisksFilled = _interopRequireDefault(require("./IconAllRisksFilled"));

var _IconTenPercentFilled = _interopRequireDefault(require("./IconTenPercentFilled"));

var _IconDroneFilled = _interopRequireDefault(require("./IconDroneFilled"));

var _IconEmergencyBrakeFilled = _interopRequireDefault(require("./IconEmergencyBrakeFilled"));

var _IconCruiseControlFilled = _interopRequireDefault(require("./IconCruiseControlFilled"));

var _IconSupportFilled = _interopRequireDefault(require("./IconSupportFilled"));

var _IconBlindSpotFilled = _interopRequireDefault(require("./IconBlindSpotFilled"));

var _IconDamageAnimalsFilled = _interopRequireDefault(require("./IconDamageAnimalsFilled"));

var _IconLaneControlFilled = _interopRequireDefault(require("./IconLaneControlFilled"));

var _IconBAPlusPlusFilled = _interopRequireDefault(require("./IconBAPlusPlusFilled"));

var _IconBAPlusFilled = _interopRequireDefault(require("./IconBAPlusFilled"));

var _IconReplacementFilled = _interopRequireDefault(require("./IconReplacementFilled"));

var _IconAttentionAssistanceFilled = _interopRequireDefault(require("./IconAttentionAssistanceFilled"));

var _IconECallFilled = _interopRequireDefault(require("./IconECallFilled"));

var _IconCoverageFilled = _interopRequireDefault(require("./IconCoverageFilled"));

var _IconJokerFilled = _interopRequireDefault(require("./IconJokerFilled"));

var _IconExtraObjectDamageFilled = _interopRequireDefault(require("./IconExtraObjectDamageFilled"));

var _IconDriverFilled = _interopRequireDefault(require("./IconDriverFilled"));

var _IconExtraCarDamageFilled = _interopRequireDefault(require("./IconExtraCarDamageFilled"));

var _IconMirrorBreakageFilled = _interopRequireDefault(require("./IconMirrorBreakageFilled"));

var _IconParkingFilled = _interopRequireDefault(require("./IconParkingFilled"));

var _IconTravellingFilled = _interopRequireDefault(require("./IconTravellingFilled"));

var _IconSearchCarFilled = _interopRequireDefault(require("./IconSearchCarFilled"));

var _IconSavingFilled = _interopRequireDefault(require("./IconSavingFilled"));

var _IconFlightAcceptedFilled = _interopRequireDefault(require("./IconFlightAcceptedFilled"));

var _IconFlightCanceledFilled = _interopRequireDefault(require("./IconFlightCanceledFilled"));

var _IconFlightDelayedFilled = _interopRequireDefault(require("./IconFlightDelayedFilled"));

var _IconFlightMissedFilled = _interopRequireDefault(require("./IconFlightMissedFilled"));

var _IconCancelFlightFilled = _interopRequireDefault(require("./IconCancelFlightFilled"));

var _IconMobilityFilled = _interopRequireDefault(require("./IconMobilityFilled"));

var _IconCertificateFilled = _interopRequireDefault(require("./IconCertificateFilled"));

var _IconInjuredFilled = _interopRequireDefault(require("./IconInjuredFilled"));

var _IconDragHandlerFilled = _interopRequireDefault(require("./IconDragHandlerFilled"));

var _Upload = _interopRequireDefault(require("./Upload"));

var _IconPlusFilled = _interopRequireDefault(require("./IconPlusFilled"));

var _IconPencilFilled = _interopRequireDefault(require("./IconPencilFilled"));

var _IconCabrioFilled = _interopRequireDefault(require("./IconCabrioFilled"));

var _IconSuvFilled = _interopRequireDefault(require("./IconSuvFilled"));

var _IconCloseFamily = _interopRequireDefault(require("./IconCloseFamily"));

var _IconHeavyWork = _interopRequireDefault(require("./IconHeavyWork"));

var _IconParkingAids = _interopRequireDefault(require("./IconParkingAids"));

var _IconPedestrian = _interopRequireDefault(require("./IconPedestrian"));

var _IconPrint = _interopRequireDefault(require("./IconPrint"));

var _IconStats = _interopRequireDefault(require("./IconStats"));

var _IconWoman = _interopRequireDefault(require("./IconWoman"));

var _IconPorch = _interopRequireDefault(require("./IconPorch"));

var _IconElectricBike = _interopRequireDefault(require("./IconElectricBike"));

var _IconHeavyScooter = _interopRequireDefault(require("./IconHeavyScooter"));

var _IconLightScooter = _interopRequireDefault(require("./IconLightScooter"));

var _IconMotor = _interopRequireDefault(require("./IconMotor"));

var _IconCompanyCar = _interopRequireDefault(require("./IconCompanyCar"));

var _IconSixWheeler = _interopRequireDefault(require("./IconSixWheeler"));

var _IconMinus = _interopRequireDefault(require("./IconMinus"));

var _IconEngineFilled = _interopRequireDefault(require("./IconEngineFilled"));

var _IconInfoFilled = _interopRequireDefault(require("./IconInfoFilled"));

var _IconPassengerFilled = _interopRequireDefault(require("./IconPassengerFilled"));

var _IconHealthFilled = _interopRequireDefault(require("./IconHealthFilled"));

var _IconBAXL = _interopRequireDefault(require("./IconBAXL"));

var _IconBAPlusPlusXL = _interopRequireDefault(require("./IconBAPlusPlusXL"));

var _IconDownloadFilled = _interopRequireDefault(require("./IconDownloadFilled"));

var _IconVanFilled = _interopRequireDefault(require("./IconVanFilled"));

var _IconJeepFilled = _interopRequireDefault(require("./IconJeepFilled"));

var _IconShoppingCartFilled = _interopRequireDefault(require("./IconShoppingCartFilled"));

var _IconShoppingBasket = _interopRequireDefault(require("./IconShoppingBasket"));

var _IconChevronDown = _interopRequireDefault(require("./IconChevronDown"));

var _IconClipBoard = _interopRequireDefault(require("./IconClipBoard"));

var _StatusIcon = _interopRequireDefault(require("./StatusIcon"));

var _IconHyperLink = _interopRequireDefault(require("./IconHyperLink"));

var _IconPopup = _interopRequireDefault(require("./IconPopup"));

var _IconCustomLink = _interopRequireDefault(require("./IconCustomLink"));

var _IconBedroomFilled = _interopRequireDefault(require("./IconBedroomFilled"));

var _IconBathroomFilled = _interopRequireDefault(require("./IconBathroomFilled"));

var _IconDressingFilled = _interopRequireDefault(require("./IconDressingFilled"));

var _IconFireplaceFilled = _interopRequireDefault(require("./IconFireplaceFilled"));

var _IconKitchenFilled = _interopRequireDefault(require("./IconKitchenFilled"));

var _IconOtherRoomsFilled = _interopRequireDefault(require("./IconOtherRoomsFilled"));

var _IconPlayroomFilled = _interopRequireDefault(require("./IconPlayroomFilled"));

var _IconPrivateHomeOfficeFilled = _interopRequireDefault(require("./IconPrivateHomeOfficeFilled"));

var _IconStorageRoomFilled = _interopRequireDefault(require("./IconStorageRoomFilled"));

var _IconWashingRoomFilled = _interopRequireDefault(require("./IconWashingRoomFilled"));

var _IconWellnessRoomFilled = _interopRequireDefault(require("./IconWellnessRoomFilled"));

var _IconStar = _interopRequireDefault(require("./IconStar"));

var _IconCarGlassBreakage = _interopRequireDefault(require("./IconCarGlassBreakage"));

var _IconCarCollision = _interopRequireDefault(require("./IconCarCollision"));

var _IconResetFilled = _interopRequireDefault(require("./IconResetFilled"));

var _IconPrintWhite = _interopRequireDefault(require("./IconPrintWhite"));

var _IconCompare = _interopRequireDefault(require("./IconCompare"));

var _IconClockFilled = _interopRequireDefault(require("./IconClockFilled"));

var _IconArrow = _interopRequireDefault(require("./IconArrow"));

var _IconBreadCrumbChevronRight = _interopRequireDefault(require("./IconBreadCrumbChevronRight"));

var _IconSpeedAssistance = _interopRequireDefault(require("./IconSpeedAssistance"));

var _IconRearCrossTrafficWarning = _interopRequireDefault(require("./IconRearCrossTrafficWarning"));

var _IconRearEmergencyBreaking = _interopRequireDefault(require("./IconRearEmergencyBreaking"));

var _IconLaneCenteringAssist = _interopRequireDefault(require("./IconLaneCenteringAssist"));

var _IconLaneDepartingWarning = _interopRequireDefault(require("./IconLaneDepartingWarning"));

var _IconPedestrianDetection = _interopRequireDefault(require("./IconPedestrianDetection"));

var _IconPerformance = _interopRequireDefault(require("./IconPerformance"));

var _IconElectronicStabilityControl = _interopRequireDefault(require("./IconElectronicStabilityControl"));

var _IconForwardCollisionWarning = _interopRequireDefault(require("./IconForwardCollisionWarning"));

var _IconFrontEmergencyBraking = _interopRequireDefault(require("./IconFrontEmergencyBraking"));

var _IconHighSpeedEmergencyBreaking = _interopRequireDefault(require("./IconHighSpeedEmergencyBreaking"));

var _IconABS = _interopRequireDefault(require("./IconABS"));

var _IconCityEmergencyBraking = _interopRequireDefault(require("./IconCityEmergencyBraking"));

var _IconSafetySystems = _interopRequireDefault(require("./IconSafetySystems"));

var _IconSafetySystemsPlus = _interopRequireDefault(require("./IconSafetySystemsPlus"));

var _IconThumbsUp = _interopRequireDefault(require("./IconThumbsUp"));

var _IconThumbsDown = _interopRequireDefault(require("./IconThumbsDown"));

var _IconMeasurePlus = _interopRequireDefault(require("./IconMeasurePlus"));

var _IconHousePlus = _interopRequireDefault(require("./IconHousePlus"));

var _IconDistances = _interopRequireDefault(require("./IconDistances"));

var _IconRooms = _interopRequireDefault(require("./IconRooms"));

var _IconAppartment = _interopRequireDefault(require("./IconAppartment"));

var _IconAttached = _interopRequireDefault(require("./IconAttached"));

var _IconSemiDetached = _interopRequireDefault(require("./IconSemiDetached"));

var _IconFullscreen = _interopRequireDefault(require("./IconFullscreen"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = function Icon(_ref) {
  var type = _ref.type;

  switch (type) {
    case 'home':
      return /*#__PURE__*/_react.default.createElement(_IconPropertyFilled.default, null);

    case 'car':
      return /*#__PURE__*/_react.default.createElement(_IconCarFilled.default, null);

    case 'fire':
      return /*#__PURE__*/_react.default.createElement(_IconFireFilled.default, null);

    case 'theft':
      return /*#__PURE__*/_react.default.createElement(_IconTheftFilled.default, null);

    case 'others':
      return /*#__PURE__*/_react.default.createElement(_IconOthersFilled.default, null);

    case 'tax':
      return /*#__PURE__*/_react.default.createElement(_IconTaxFilled.default, null);

    case 'legal':
      return /*#__PURE__*/_react.default.createElement(_IconLegalFilled.default, null);

    case 'notification':
      return /*#__PURE__*/_react.default.createElement(_IconNotificationBellFilled.default, null);

    case 'flight':
      return /*#__PURE__*/_react.default.createElement(_IconFlightFilled.default, null);

    case 'consumer':
      return /*#__PURE__*/_react.default.createElement(_IconConsumerFilled.default, null);

    case 'mechanic-breakdown':
      return /*#__PURE__*/_react.default.createElement(_IconMechanicalBreakdownFilled.default, null);

    case 'oil':
      return /*#__PURE__*/_react.default.createElement(_IconOilFilled.default, null);

    case 'history':
      return /*#__PURE__*/_react.default.createElement(_IconHistoryFilled.default, null);

    case 'income':
      return /*#__PURE__*/_react.default.createElement(_IconIncomeFilled.default, null);

    case 'electricity':
      return /*#__PURE__*/_react.default.createElement(_IconElectricityFilled.default, null);

    case 'thawing':
      return /*#__PURE__*/_react.default.createElement(_IconThawingFilled.default, null);

    case 'water-damage':
      return /*#__PURE__*/_react.default.createElement(_IconWaterDamageFilled.default, null);

    case 'snow-pressure':
      return /*#__PURE__*/_react.default.createElement(_IconSnowPressureFilled.default, null);

    case 'cracks':
      return /*#__PURE__*/_react.default.createElement(_IconCracksFilled.default, null);

    case 'dry-rot':
      return /*#__PURE__*/_react.default.createElement(_IconDryRotFilled.default, null);

    case 'scorch-damage':
      return /*#__PURE__*/_react.default.createElement(_IconScorchDamageFilled.default, null);

    case 'property':
      return /*#__PURE__*/_react.default.createElement(_IconPropertyFilled.default, null);

    case 'baggage':
      return /*#__PURE__*/_react.default.createElement(_IconBaggageFilled.default, null);

    case 'natural-disaster':
      return /*#__PURE__*/_react.default.createElement(_IconNaturalDisasterFilled.default, null);

    case 'assistance-person':
      return /*#__PURE__*/_react.default.createElement(_IconAssistancePersonFilled.default, null);

    case 'assistance-car':
      return /*#__PURE__*/_react.default.createElement(_IconAssistanceCarFilled.default, null);

    case 'new-car':
      return /*#__PURE__*/_react.default.createElement(_IconNewCarFilled.default, null);

    case 'looking-for-car':
      return /*#__PURE__*/_react.default.createElement(_IconLookingForCarFilled.default, null);

    case 'bought-car':
      return /*#__PURE__*/_react.default.createElement(_IconBoughtCarFilled.default, null);

    case 'secondhand-car':
      return /*#__PURE__*/_react.default.createElement(_IconSecondHandCarFilled.default, null);

    case 'accident':
      return /*#__PURE__*/_react.default.createElement(_IconAccidentFilled.default, null);

    case 'web-world':
      return /*#__PURE__*/_react.default.createElement(_IconWebWorldFilled.default, null);

    case 'web':
      return /*#__PURE__*/_react.default.createElement(_IconWebFilled.default, null);

    case 'personal-liability':
      return /*#__PURE__*/_react.default.createElement(_IconPersonalLiabilityFilled.default, null);

    case 'liability-building':
      return /*#__PURE__*/_react.default.createElement(_IconLiabilitybuildingFilled.default, null);

    case 'landlord':
      return /*#__PURE__*/_react.default.createElement(_IconLandlordFilled.default, null);

    case 'tenant':
      return /*#__PURE__*/_react.default.createElement(_IconTenantFilled.default, null);

    case 'glass-breakage':
      return /*#__PURE__*/_react.default.createElement(_IconGlassBreakageFilled.default, null);

    case 'action-dropdown':
      return /*#__PURE__*/_react.default.createElement(_IconActionDropDown.default, null);

    case 'action-close':
      return /*#__PURE__*/_react.default.createElement(_IconActionClose.default, null);

    case 'action-marker':
      return /*#__PURE__*/_react.default.createElement(_IconActionMarker.default, null);

    case 'action-phone':
      return /*#__PURE__*/_react.default.createElement(_IconActionPhone.default, null);

    case 'action-power':
      return /*#__PURE__*/_react.default.createElement(_IconActionPower.default, null);

    case 'action-left':
      return /*#__PURE__*/_react.default.createElement(_IconActionChevronLeft.default, null);

    case 'action-right':
      return /*#__PURE__*/_react.default.createElement(_IconActionChevronRight.default, null);

    case 'action-eye':
      return /*#__PURE__*/_react.default.createElement(_IconActionEye.default, null);

    case 'action-eye-crossed':
      return /*#__PURE__*/_react.default.createElement(_IconActionEyeCrossed.default, null);

    case 'action-read':
      return /*#__PURE__*/_react.default.createElement(_IconActionRead.default, null);

    case 'action-unread':
      return /*#__PURE__*/_react.default.createElement(_IconActionUnRead.default, null);

    case 'action-plus':
      return /*#__PURE__*/_react.default.createElement(_IconActionPlus.default, null);

    case 'action-message':
      return /*#__PURE__*/_react.default.createElement(_IconActionMessage.default, null);

    case 'status-exclamation':
      return /*#__PURE__*/_react.default.createElement(_IconStatusExclamation.default, null);

    case 'status-check':
      return /*#__PURE__*/_react.default.createElement(_IconStatusCheck.default, null);

    case 'student':
      return /*#__PURE__*/_react.default.createElement(_IconStudent.default, null);

    case 'dashboard':
      return /*#__PURE__*/_react.default.createElement(_IconDashboard.default, null);

    case 'settings':
      return /*#__PURE__*/_react.default.createElement(_IconSettingsFilled.default, null);

    case 'underwriting':
      return /*#__PURE__*/_react.default.createElement(_IconUnderwritingFilled.default, null);

    case 'claims':
      return /*#__PURE__*/_react.default.createElement(_IconClaimsFilled.default, null);

    case 'toolkit':
      return /*#__PURE__*/_react.default.createElement(_IconToolkitFilled.default, null);

    case 'family':
      return /*#__PURE__*/_react.default.createElement(_IconFamilyFilled.default, null);

    case 'active-pv':
      return /*#__PURE__*/_react.default.createElement(_IconActivePVFilled.default, null);

    case 'witness':
      return /*#__PURE__*/_react.default.createElement(_IconWitnessFilled.default, null);

    case 'quality':
      return /*#__PURE__*/_react.default.createElement(_IconQualityFilled.default, null);

    case 'sms':
      return /*#__PURE__*/_react.default.createElement(_IconSmsFilled.default, null);

    case 'work-accident':
      return /*#__PURE__*/_react.default.createElement(_IconWorkAccidentFilled.default, null);

    case 'id':
      return /*#__PURE__*/_react.default.createElement(_IconIdFilled.default, null);

    case 'document':
      return /*#__PURE__*/_react.default.createElement(_IconDocumentFilled.default, null);

    case 'attic':
      return /*#__PURE__*/_react.default.createElement(_IconAtticFilled.default, null);

    case 'basement':
      return /*#__PURE__*/_react.default.createElement(_IconBasementFilled.default, null);

    case 'passive-house':
      return /*#__PURE__*/_react.default.createElement(_IconPassiveHouseFilled.default, null);

    case 'construction':
      return /*#__PURE__*/_react.default.createElement(_IconConstructionFilled.default, null);

    case 'stone':
      return /*#__PURE__*/_react.default.createElement(_IconStoneFilled.default, null);

    case 'corn':
      return /*#__PURE__*/_react.default.createElement(_IconCornFilled.default, null);

    case 'measure':
      return /*#__PURE__*/_react.default.createElement(_IconMeasureFilled.default, null);

    case 'jewelry':
      return /*#__PURE__*/_react.default.createElement(_IconJewelryFilled.default, null);

    case 'art':
      return /*#__PURE__*/_react.default.createElement(_IconArtFilled.default, null);

    case 'furniture':
      return /*#__PURE__*/_react.default.createElement(_IconFurnitureFilled.default, null);

    case 'garage':
      return /*#__PURE__*/_react.default.createElement(_IconGarageFilled.default, null);

    case 'guests':
      return /*#__PURE__*/_react.default.createElement(_IconGuestsFilled.default, null);

    case 'property-extra':
      return /*#__PURE__*/_react.default.createElement(_IconPropertyExtraFilled.default, null);

    case 'home-office':
      return /*#__PURE__*/_react.default.createElement(_IconHomeOfficeFilled.default, null);

    case 'pool':
      return /*#__PURE__*/_react.default.createElement(_IconPoolFilled.default, null);

    case 'shed':
      return /*#__PURE__*/_react.default.createElement(_IconShedFilled.default, null);

    case 'garden':
      return /*#__PURE__*/_react.default.createElement(_IconGardenFilled.default, null);

    case 'vacation':
      return /*#__PURE__*/_react.default.createElement(_IconVacationFilled.default, null);

    case 'surroundings':
      return /*#__PURE__*/_react.default.createElement(_IconSurroundingsFilled.default, null);

    case 'pets':
      return /*#__PURE__*/_react.default.createElement(_IconPetsFilled.default, null);

    case 'e-step':
      return /*#__PURE__*/_react.default.createElement(_IconEStepFilled.default, null);

    case 'bike':
      return /*#__PURE__*/_react.default.createElement(_IconBikeFilled.default, null);

    case 'shared-economy':
      return /*#__PURE__*/_react.default.createElement(_IconSharedEconomyFilled.default, null);

    case 'solar-panels':
      return /*#__PURE__*/_react.default.createElement(_IconSolarPanelsFilled.default, null);

    case 'disability':
      return /*#__PURE__*/_react.default.createElement(_IconDisabilityFilled.default, null);

    case 'children':
      return /*#__PURE__*/_react.default.createElement(_IconChildrenFilled.default, null);

    case 'computer':
      return /*#__PURE__*/_react.default.createElement(_IconComputerFilled.default, null);

    case 'all-risks':
      return /*#__PURE__*/_react.default.createElement(_IconAllRisksFilled.default, null);

    case 'ten-percent':
      return /*#__PURE__*/_react.default.createElement(_IconTenPercentFilled.default, null);

    case 'drone':
      return /*#__PURE__*/_react.default.createElement(_IconDroneFilled.default, null);

    case 'emergency-brake':
      return /*#__PURE__*/_react.default.createElement(_IconEmergencyBrakeFilled.default, null);

    case 'cruise-control':
      return /*#__PURE__*/_react.default.createElement(_IconCruiseControlFilled.default, null);

    case 'support':
      return /*#__PURE__*/_react.default.createElement(_IconSupportFilled.default, null);

    case 'blind-spot':
      return /*#__PURE__*/_react.default.createElement(_IconBlindSpotFilled.default, null);

    case 'damage-animals':
      return /*#__PURE__*/_react.default.createElement(_IconDamageAnimalsFilled.default, null);

    case 'lane-control':
      return /*#__PURE__*/_react.default.createElement(_IconLaneControlFilled.default, null);

    case 'ba-plus-plus':
      return /*#__PURE__*/_react.default.createElement(_IconBAPlusPlusFilled.default, null);

    case 'ba-plus':
      return /*#__PURE__*/_react.default.createElement(_IconBAPlusFilled.default, null);

    case 'replacement':
      return /*#__PURE__*/_react.default.createElement(_IconReplacementFilled.default, null);

    case 'attention-assistance':
      return /*#__PURE__*/_react.default.createElement(_IconAttentionAssistanceFilled.default, null);

    case 'e-call':
      return /*#__PURE__*/_react.default.createElement(_IconECallFilled.default, null);

    case 'coverage':
      return /*#__PURE__*/_react.default.createElement(_IconCoverageFilled.default, null);

    case 'joker':
      return /*#__PURE__*/_react.default.createElement(_IconJokerFilled.default, null);

    case 'extra-object-damage':
      return /*#__PURE__*/_react.default.createElement(_IconExtraObjectDamageFilled.default, null);

    case 'driver':
      return /*#__PURE__*/_react.default.createElement(_IconDriverFilled.default, null);

    case 'extra-car-damage':
      return /*#__PURE__*/_react.default.createElement(_IconExtraCarDamageFilled.default, null);

    case 'mirror-breakage':
      return /*#__PURE__*/_react.default.createElement(_IconMirrorBreakageFilled.default, null);

    case 'parking':
      return /*#__PURE__*/_react.default.createElement(_IconParkingFilled.default, null);

    case 'travelling':
      return /*#__PURE__*/_react.default.createElement(_IconTravellingFilled.default, null);

    case 'search-car':
      return /*#__PURE__*/_react.default.createElement(_IconSearchCarFilled.default, null);

    case 'saving':
      return /*#__PURE__*/_react.default.createElement(_IconSavingFilled.default, null);

    case 'flight-accepted':
      return /*#__PURE__*/_react.default.createElement(_IconFlightAcceptedFilled.default, null);

    case 'flight-canceled':
      return /*#__PURE__*/_react.default.createElement(_IconFlightCanceledFilled.default, null);

    case 'flight-delayed':
      return /*#__PURE__*/_react.default.createElement(_IconFlightDelayedFilled.default, null);

    case 'flight-missed':
      return /*#__PURE__*/_react.default.createElement(_IconFlightMissedFilled.default, null);

    case 'cancel-flight':
      return /*#__PURE__*/_react.default.createElement(_IconCancelFlightFilled.default, null);

    case 'mobility':
      return /*#__PURE__*/_react.default.createElement(_IconMobilityFilled.default, null);

    case 'certificate':
      return /*#__PURE__*/_react.default.createElement(_IconCertificateFilled.default, null);

    case 'injured':
      return /*#__PURE__*/_react.default.createElement(_IconInjuredFilled.default, null);

    case 'drag-handler':
      return /*#__PURE__*/_react.default.createElement(_IconDragHandlerFilled.default, null);

    case 'upload':
      return /*#__PURE__*/_react.default.createElement(_Upload.default, null);

    case 'plus':
      return /*#__PURE__*/_react.default.createElement(_IconPlusFilled.default, null);

    case 'pencil':
      return /*#__PURE__*/_react.default.createElement(_IconPencilFilled.default, null);

    case 'cabrio':
      return /*#__PURE__*/_react.default.createElement(_IconCabrioFilled.default, null);

    case 'suv':
      return /*#__PURE__*/_react.default.createElement(_IconSuvFilled.default, null);

    case 'close-family':
      return /*#__PURE__*/_react.default.createElement(_IconCloseFamily.default, null);

    case 'heavy-work':
      return /*#__PURE__*/_react.default.createElement(_IconHeavyWork.default, null);

    case 'parking-aids':
      return /*#__PURE__*/_react.default.createElement(_IconParkingAids.default, null);

    case 'pedestrian':
      return /*#__PURE__*/_react.default.createElement(_IconPedestrian.default, null);

    case 'print':
      return /*#__PURE__*/_react.default.createElement(_IconPrint.default, null);

    case 'stats':
      return /*#__PURE__*/_react.default.createElement(_IconStats.default, null);

    case 'woman':
      return /*#__PURE__*/_react.default.createElement(_IconWoman.default, null);

    case 'porch':
      return /*#__PURE__*/_react.default.createElement(_IconPorch.default, null);

    case 'electric-bike':
      return /*#__PURE__*/_react.default.createElement(_IconElectricBike.default, null);

    case 'heavy-scooter':
      return /*#__PURE__*/_react.default.createElement(_IconHeavyScooter.default, null);

    case 'light-scooter':
      return /*#__PURE__*/_react.default.createElement(_IconLightScooter.default, null);

    case 'motor':
      return /*#__PURE__*/_react.default.createElement(_IconMotor.default, null);

    case 'company-car':
      return /*#__PURE__*/_react.default.createElement(_IconCompanyCar.default, null);

    case 'six-wheeler':
      return /*#__PURE__*/_react.default.createElement(_IconSixWheeler.default, null);

    case 'motor':
      return /*#__PURE__*/_react.default.createElement(_IconMotor.default, null);

    case 'minus':
      return /*#__PURE__*/_react.default.createElement(_IconMinus.default, null);

    case 'engine':
      return /*#__PURE__*/_react.default.createElement(_IconEngineFilled.default, null);

    case 'info':
      return /*#__PURE__*/_react.default.createElement(_IconInfoFilled.default, null);

    case 'passenger':
      return /*#__PURE__*/_react.default.createElement(_IconPassengerFilled.default, null);

    case 'health':
      return /*#__PURE__*/_react.default.createElement(_IconHealthFilled.default, null);

    case 'ba-xl':
      return /*#__PURE__*/_react.default.createElement(_IconBAXL.default, null);

    case 'ba-plus-plus-xl':
      return /*#__PURE__*/_react.default.createElement(_IconBAPlusPlusXL.default, null);

    case 'download':
      return /*#__PURE__*/_react.default.createElement(_IconDownloadFilled.default, null);

    case 'van':
      return /*#__PURE__*/_react.default.createElement(_IconVanFilled.default, null);

    case 'jeep':
      return /*#__PURE__*/_react.default.createElement(_IconJeepFilled.default, null);

    case 'shopping-cart':
      return /*#__PURE__*/_react.default.createElement(_IconShoppingCartFilled.default, null);

    case 'shopping-basket':
      return /*#__PURE__*/_react.default.createElement(_IconShoppingBasket.default, null);

    case 'chevron-down':
      return /*#__PURE__*/_react.default.createElement(_IconChevronDown.default, null);

    case 'clipboard':
      return /*#__PURE__*/_react.default.createElement(_IconClipBoard.default, null);

    case 'status':
      return /*#__PURE__*/_react.default.createElement(_StatusIcon.default, null);

    case 'hyperlink':
      return /*#__PURE__*/_react.default.createElement(_IconHyperLink.default, null);

    case 'popup':
      return /*#__PURE__*/_react.default.createElement(_IconPopup.default, null);

    case 'custom-link':
      return /*#__PURE__*/_react.default.createElement(_IconCustomLink.default, null);

    case 'bedroom':
      return /*#__PURE__*/_react.default.createElement(_IconBedroomFilled.default, null);

    case 'bathroom':
      return /*#__PURE__*/_react.default.createElement(_IconBathroomFilled.default, null);

    case 'dressing':
      return /*#__PURE__*/_react.default.createElement(_IconDressingFilled.default, null);

    case 'fireplace':
      return /*#__PURE__*/_react.default.createElement(_IconFireplaceFilled.default, null);

    case 'kitchen':
      return /*#__PURE__*/_react.default.createElement(_IconKitchenFilled.default, null);

    case 'other-rooms':
      return /*#__PURE__*/_react.default.createElement(_IconOtherRoomsFilled.default, null);

    case 'playroom':
      return /*#__PURE__*/_react.default.createElement(_IconPlayroomFilled.default, null);

    case 'private-home-office':
      return /*#__PURE__*/_react.default.createElement(_IconPrivateHomeOfficeFilled.default, null);

    case 'storage-room':
      return /*#__PURE__*/_react.default.createElement(_IconStorageRoomFilled.default, null);

    case 'washing-room':
      return /*#__PURE__*/_react.default.createElement(_IconWashingRoomFilled.default, null);

    case 'wellness-room':
      return /*#__PURE__*/_react.default.createElement(_IconWellnessRoomFilled.default, null);

    case 'star':
      return /*#__PURE__*/_react.default.createElement(_IconStar.default, null);

    case 'car-glass-breakage':
      return /*#__PURE__*/_react.default.createElement(_IconCarGlassBreakage.default, null);

    case 'car-collision':
      return /*#__PURE__*/_react.default.createElement(_IconCarCollision.default, null);

    case 'reset':
      return /*#__PURE__*/_react.default.createElement(_IconResetFilled.default, null);

    case 'print-white':
      return /*#__PURE__*/_react.default.createElement(_IconPrintWhite.default, null);

    case 'compare':
      return /*#__PURE__*/_react.default.createElement(_IconCompare.default, null);

    case 'clock':
      return /*#__PURE__*/_react.default.createElement(_IconClockFilled.default, null);

    case 'arrow':
      return /*#__PURE__*/_react.default.createElement(_IconArrow.default, null);

    case 'bread-crumb-chevron-right':
      return /*#__PURE__*/_react.default.createElement(_IconBreadCrumbChevronRight.default, null);

    case 'speed-assistance':
      return /*#__PURE__*/_react.default.createElement(_IconSpeedAssistance.default, null);

    case 'rear-cross-traffic-warning':
      return /*#__PURE__*/_react.default.createElement(_IconRearCrossTrafficWarning.default, null);

    case 'rear-emergency-breaking':
      return /*#__PURE__*/_react.default.createElement(_IconRearEmergencyBreaking.default, null);

    case 'lane-centering-assist':
      return /*#__PURE__*/_react.default.createElement(_IconLaneCenteringAssist.default, null);

    case 'lane-depart-warning':
      return /*#__PURE__*/_react.default.createElement(_IconLaneDepartingWarning.default, null);

    case 'pedestrian-detection':
      return /*#__PURE__*/_react.default.createElement(_IconPedestrianDetection.default, null);

    case 'performance':
      return /*#__PURE__*/_react.default.createElement(_IconPerformance.default, null);

    case 'electronic-stability-control':
      return /*#__PURE__*/_react.default.createElement(_IconElectronicStabilityControl.default, null);

    case 'forward-collision-warning':
      return /*#__PURE__*/_react.default.createElement(_IconForwardCollisionWarning.default, null);

    case 'emergency-breaking':
      return /*#__PURE__*/_react.default.createElement(_IconFrontEmergencyBraking.default, null);

    case 'high-speed-emergency-breaking':
      return /*#__PURE__*/_react.default.createElement(_IconHighSpeedEmergencyBreaking.default, null);

    case 'abs':
      return /*#__PURE__*/_react.default.createElement(_IconABS.default, null);

    case 'city-emergency-braking':
      return /*#__PURE__*/_react.default.createElement(_IconCityEmergencyBraking.default, null);

    case 'safety-systems':
      return /*#__PURE__*/_react.default.createElement(_IconSafetySystems.default, null);

    case 'safety-systems-plus':
      return /*#__PURE__*/_react.default.createElement(_IconSafetySystemsPlus.default, null);

    case 'thumbs-up':
      return /*#__PURE__*/_react.default.createElement(_IconThumbsUp.default, null);

    case 'thumbs-down':
      return /*#__PURE__*/_react.default.createElement(_IconThumbsDown.default, null);

    case 'measure-plus':
      return /*#__PURE__*/_react.default.createElement(_IconMeasurePlus.default, null);

    case 'house-plus':
      return /*#__PURE__*/_react.default.createElement(_IconHousePlus.default, null);

    case 'distance':
      return /*#__PURE__*/_react.default.createElement(_IconDistances.default, null);

    case 'rooms':
      return /*#__PURE__*/_react.default.createElement(_IconRooms.default, null);

    case 'appartment':
      return /*#__PURE__*/_react.default.createElement(_IconAppartment.default, null);

    case 'attached':
      return /*#__PURE__*/_react.default.createElement(_IconAttached.default, null);

    case 'semi-detached':
      return /*#__PURE__*/_react.default.createElement(_IconSemiDetached.default, null);

    case 'full-screen':
      return /*#__PURE__*/_react.default.createElement(_IconFullscreen.default, null);

    default:
      return /*#__PURE__*/_react.default.createElement(_IconOthersFilled.default, null);
  }
};

Icon.defaultProps = {
  type: 'home'
};
_StatusIcon.default.propTypes = {
  /** What type of icon should be displayed? */
  type: _propTypes.string
};
var _default = Icon;
exports.default = _default;